// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const aiModelTestInAuthMax = 40;

export const aiModelTestInCapabilityDefault = `chat`;
export const aiModelTestInConfigDefault = {};
export const aiModelTestInDisplayNameMax = 200;

export const aiModelTestInEnabledDefault = true;
export const aiModelTestInHostingMax = 40;

export const aiModelTestInKeyOneMax = 120;

export const aiModelTestInMaxOutputTokensMin = 256;
export const aiModelTestInMaxOutputTokensMax = 200000;

export const aiModelTestInModelIdMax = 300;

export const aiModelTestInPriceCacheReadOneMin = 0;
export const aiModelTestInPriceCacheReadOneMax = 99999999.9999;

export const aiModelTestInPriceCacheWriteOneMin = 0;
export const aiModelTestInPriceCacheWriteOneMax = 99999999.9999;

export const aiModelTestInPriceInputOneMin = 0;
export const aiModelTestInPriceInputOneMax = 99999999.9999;

export const aiModelTestInPriceOutputOneMin = 0;
export const aiModelTestInPriceOutputOneMax = 99999999.9999;

export const aiModelTestInSortOrderDefault = 0;

export const AiModelTestIn = zod.object({
  "auth": zod.string().max(aiModelTestInAuthMax),
  "capability": zod.enum(['chat', 'embedding']).default(aiModelTestInCapabilityDefault),
  "config": zod.record(zod.string(), zod.unknown()).default(aiModelTestInConfigDefault),
  "display_name": zod.string().min(1).max(aiModelTestInDisplayNameMax),
  "enabled": zod.boolean().default(aiModelTestInEnabledDefault),
  "hosting": zod.string().max(aiModelTestInHostingMax),
  "key": zod.union([zod.string().max(aiModelTestInKeyOneMax),zod.null()]).optional(),
  "max_output_tokens": zod.int().min(aiModelTestInMaxOutputTokensMin).max(aiModelTestInMaxOutputTokensMax),
  "model_id": zod.string().min(1).max(aiModelTestInModelIdMax),
  "price_cache_read": zod.union([zod.number().min(aiModelTestInPriceCacheReadOneMin).max(aiModelTestInPriceCacheReadOneMax),zod.string()]),
  "price_cache_write": zod.union([zod.number().min(aiModelTestInPriceCacheWriteOneMin).max(aiModelTestInPriceCacheWriteOneMax),zod.string()]),
  "price_input": zod.union([zod.number().min(aiModelTestInPriceInputOneMin).max(aiModelTestInPriceInputOneMax),zod.string()]),
  "price_output": zod.union([zod.number().min(aiModelTestInPriceOutputOneMin).max(aiModelTestInPriceOutputOneMax),zod.string()]),
  "sort_order": zod.int().default(aiModelTestInSortOrderDefault)
});

export type AiModelTestIn = zod.input<typeof AiModelTestIn>;
export type AiModelTestInOutput = zod.output<typeof AiModelTestIn>;
